import '../filter_view.js.coffee'

Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST["backbone/templates/monitoring/filters/grouped_elements/grouped_elements_filter_modal"]

  events:
    'click .edit-elements' : 'onEditElements'
    'click #elements-modal-done': 'onApply'
    'click .one-click-open' : 'oneClickView'

  initialize: (@options = {}) ->
    super(@options)
    @groups_logic = @getGroupsLogic()
    @possible_elements = @initilizeElements()
    @applied_elements = @initilizeElements()

  render : ->
    @_fillElements(@getGroupsElements())
    [@firstGroupView, @secondGroupView, @excludedGroupView] = _.map(@viewsIds(), @viewFor)
    @$el.html(@template({ self: @ }))
    _.each([@firstGroupView, @secondGroupView, @excludedGroupView], (view) =>
      @$el.find('#' + view.id).replaceWith(view.render().el)
      @listenTo(view, 'added:customElement', @onAddCustomElement)
      @listenTo(view, 'removed:customElement', @onRemoveCustomElement)
      @listenTo(view, 'activate', @activate)
    )
    @

  getTitle: =>
    I18n.t("monitoring.dashboard.filters.filter_names.#{@name}")

  getGroupsLogic: () ->
    {}

  getGroupsElements: () ->
    {}

  initilizeElements: ->
    {'first_group_elements': [], 'second_group_elements': [], 'excluded_group_elements': []}

  onAddCustomElement: ->
    _.each([@firstGroupView, @secondGroupView], (view) => view.disable())

  onRemoveCustomElement: ->
    _.each([@firstGroupView, @secondGroupView], (view) =>
      view.enable()
      view.appliedElements = []
      _.each(view.possibleElements, (element) -> element.applied = false)
    )

  activate: ->
    _.each([@firstGroupView, @secondGroupView], (view) => view.enable())

  viewsIds: ->
    ['first_group_elements', 'second_group_elements', 'excluded_group_elements']

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.GroupedElementsSelectView(@optionsFor(viewId))

  optionsFor: (viewId) =>
    id: viewId
    title: @titles()[viewId]
    possibleElements: @possible_elements[viewId]
    appliedElements: @applied_elements[viewId]
    logic: @groups_logic[viewId]
    canFilterOnlyPresent: @canFilterOnlyPresent()

  titles: ->
    {}

  # Event Methods::

  onApply: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  oneClickView: =>
    this.$el.find('.edit-elements').click()

  onEditElements: (event)->
    event.stopPropagation()
    @$el.find('#edit_elements_modal').modal()

  withPrefix: (search_query_field) ->
    search_query_field

  # Internal use Methods::

  _fillElements: (group_keys) ->
    for key, group of group_keys
      @_getAppliedAndPossibleElements(key, group, key == 'first_group_elements')

  _getAppliedAndPossibleElements: (key, group, custom_active=false) ->
    applied_elements = @_determineAppliedElements(group) || []
    all_elements = @_generateAllElements(@terms) #it may need refactor due to performance issues
    @_addCustomValues(all_elements) if custom_active
    filtered_result = @_filterUsedElements(all_elements, applied_elements)
    @applied_elements[key] = @_orderedElements(filtered_result["applied"])
    @possible_elements[key] = @_orderedElements(filtered_result["possible"])

  _determineAppliedElements: (group) ->
    i_elements = @searchQuery.get(@getName())
    if group == "primary_#{@getName()}" && i_elements.length > 0
      @searchQuery.set(group, i_elements)
      @searchQuery.set("primary_#{@getName()}_logic", 'OR')
      @groups_logic["first_group_#{@getName()}"] = false
      @searchQuery.resetField(@getName())
    @searchQuery.get(group)

  _orderedElements:(elements) ->
    result = elements.sort (a, b) ->
      if a.custom == b.custom
        if a.custom
          if a.term > b.term
            return 1
          else
            return -1
        else
          if a.description < b.description
            return -1
          else
            return 1
      else
        if a.custom
          return -1
        else
          return 1
    result

  _generateAllElements: (terms)->
    []

  _filterUsedElements: (all_elements, applied_elements) =>
    result = {"possible": [], "applied": []}
    _.each all_elements, (element) ->
      if element.term in applied_elements
        result["applied"].push element
        element.applied = true
      else
        element.applied = false
      result["possible"].push element
    result

  _noValuesDescription: ->
    "No #{@alias || @name}"

  _allValuesDescription: ->
    "All #{@alias || @name}"

  _addCustomValues: (terms) ->
    terms.push({term: "no#{@getName().titleize()}", description: @_noValuesDescription(), count: null, custom: true})
    terms.push({term: "all#{@getName().titleize()}", description: @_allValuesDescription(), count: null, custom: true})

  canFilterOnlyPresent: ->
    true
